import { useQuery } from '@tanstack/react-query';
import type { MiceFlightOptions } from '@voll-intelligence/domain';
import { queryKeys } from '@web/core/query';
import { miceRepository } from '@web/data/repositories';
import { useOrgContext } from '@web/ui/core';

/** A lista da faixa do evento de um sentido, da versão vigente: muda só com outra versão. */
export function useFlightOptions(
  projectId: string,
  needId: string,
  version: number,
  direction: 'OUTWARD' | 'RETURN',
): { data: MiceFlightOptions | undefined; isLoading: boolean; isError: boolean } {
  const { orgId } = useOrgContext();
  return useQuery({
    queryKey: queryKeys.mice.flightOptions(orgId, projectId, needId, version, direction),
    queryFn: () => miceRepository.listFlightOptions(orgId, projectId, needId, direction),
    staleTime: Infinity,
  });
}
